/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Status_ClosedInputs */

const en_settings_tickets_status_closed = /** @type {(inputs: Settings_Tickets_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Settings_Tickets_Status_ClosedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_status_closed = /** @type {((inputs?: Settings_Tickets_Status_ClosedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Status_ClosedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_status_closed(inputs)
});
export { settings_tickets_status_closed as "settings.tickets.status_closed" }